"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getObjectById = void 0;
const underscore_1 = __importDefault(require("underscore"));
const getObjectById = (_id, data) => {
    if (_id === '0') {
        return data;
    }
    if (underscore_1.default.isObject(data)) {
        const match = underscore_1.default.isMatch(data, { _id });
        if (match) {
            return data;
        }
        const values = underscore_1.default.values(data);
        const valuesFiltered = underscore_1.default.filter(values, (value) => {
            return underscore_1.default.isObject(value) || underscore_1.default.isArray(value);
        });
        for (const element of valuesFiltered) {
            const result = (0, exports.getObjectById)(_id, element);
            if (result) {
                return result;
            }
        }
    }
    if (underscore_1.default.isArray(data)) {
        for (const element of data) {
            const result = (0, exports.getObjectById)(_id, element);
            if (result) {
                return result;
            }
        }
    }
    return undefined;
};
exports.getObjectById = getObjectById;
